import { Property } from 'generated/graphql'
import React from 'react'
import { FiCopy, FiPhone } from 'react-icons/fi'
import { VscChevronUp, VscChevronDown, VscMail } from 'react-icons/vsc'

import {
  Accordion,
  AccordionItem,
  Text,
  AccordionButton,
  AccordionPanel,
  Center,
  useClipboard,
  Flex,
  Button,
  useColorModeValue
} from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { iconSizes } from 'theme'

type ContactAgentProps = {
  property: Property
}

const ContactAgent: React.FC<ContactAgentProps> = ({ property }) => {
  const [email] = React.useState(property?.agent?.email)
  const [phoneNumber] = React.useState(property?.agent?.phone_number)
  const { hasCopied: emailCopied, onCopy: onEmailCopy } = useClipboard(email ? email : '')
  const { hasCopied: phoneNumberCopied, onCopy: onPhoneNumberCopy } = useClipboard(
    phoneNumber ? phoneNumber : ''
  )
  const { t } = useTranslation()
  const bg = useColorModeValue('gray.100', 'gray.700')

  const color = useColorModeValue('gray.700', 'gray.100')
  return (
    <Accordion allowMultiple width="100%">
      <AccordionItem border="none">
        {({ isExpanded }) => (
          <>
            <AccordionButton
              flex={1}
              as={Button}
              minW={{ base: '100%', md: 44 }}
              fontWeight="extrabold"
              fontSize="x-small"
              height={12}
              rounded="2xl"
              bg={bg}
              border="none"
              color={color}
              _hover={{
                backgroundColor: 'gray.50',
                borderColor: 'gray.200'
              }}
            >
              <FiPhone size={iconSizes.md} />
              <Text width="100%" fontWeight="extrabold" fontSize="x-small" mx={2}>
                {t('property_details.contact_info')}
              </Text>
              {isExpanded ? <VscChevronUp /> : <VscChevronDown />}
            </AccordionButton>

            <AccordionPanel fontWeight="semibold">
              <Flex
                align="center"
                onClick={onPhoneNumberCopy}
                mb={2}
                color={phoneNumberCopied ? 'orange.400' : undefined}
                cursor="pointer"
                justify="space-between"
              >
                <Center>
                  <FiPhone size={iconSizes.md} />
                  <Text mx={2} fontSize="xs">
                    {property?.agent?.phone_number}
                  </Text>
                </Center>

                <FiCopy size={iconSizes.md} />
              </Flex>

              <Flex
                align="center"
                color={emailCopied ? 'orange.400' : undefined}
                onClick={onEmailCopy}
                cursor="pointer"
                justify="space-between"
              >
                <Center>
                  <VscMail size={iconSizes.md} />
                  <Text mx={2} fontSize="xs">
                    {property?.agent?.email}
                  </Text>
                </Center>

                <FiCopy size={iconSizes.md} />
              </Flex>
            </AccordionPanel>
          </>
        )}
      </AccordionItem>
    </Accordion>
  )
}

export default ContactAgent
